import { Input } from '../../../../../components/interface/input/input';
import React, { useState } from 'react';
import './challenge.sass';
import Switch from 'react-switch';
import { Button, ButtonType } from '../../../../../components/interface/button/button';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useDispatch } from 'react-redux';
import { patchChallenge, postChallenge } from '../../dashboard-challenges.slice';
import trashIcon from '../../../assets/Trash.png';
import { unwrapResult } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

const FormSchema = Yup.object().shape({
  prize_name: Yup.string()
    .min(3, 'Za krótkie!')
    .max(20, 'Za długie!')
    .required('Pole wymagane'),
  amount_of_transactions_required: Yup.number('Wpisz liczbę!').min(1, 'Minimum 1 transakcja!').max(100, 'Maksymalnie 100 transakcji!').required('Pole wymagane'),
  time_limit: Yup.number('Wpisz liczbę!').min(1, 'Minimum 1 dzień!').max(500, 'Maksymalnie 500 dni!').required('Pole wymagane'),
});

const maxNumberOfChallengesErrorString = 'You have reached the maximum number of challenges. Please upgrade your plan or deactivate/delete a challenge.';
export const Challenge = ({ isNew = false, challenge, currentPlan, onChange, onDelete, vendorId, refresh }) => {

  const [isEditing, setIsEditing] = useState(isNew || false);
  const [isActive, setIsActive] = useState(!!challenge?.is_active);
  const [image, setImage] = useState(challenge?.photo);
  const dispatch = useDispatch();
  const formik = useFormik({
    initialValues: {
      prize_name: '',
      amount_of_transactions_required: 1,
      time_limit: 1,
      is_active: false,
      photo: '',
      ...challenge
    },
    validationSchema: FormSchema,
    onSubmit: (values) => {
      //if(challenge.is_active && user.max_number_of_challenges > 0) {
      const currentNumberOfChallenges = 0;
      if(values.is_active && currentNumberOfChallenges > 0) {
        //open modal with payment
      } else {
        const data = new FormData();
        data.append('file', image);
        Object.keys(values).forEach(key => {
          data.append(key, values[key]);
        });
        data.set('is_active', isActive);

        if(challenge) {
          dispatch(patchChallenge({ vendorId, challengeId: challenge.id, payload: data }))
            .then(unwrapResult)
            .then(() => {
              setIsEditing(false);
              toast.success('Zaaktualizowane pomyślnie!');
            }).catch(onError);

        } else {
          dispatch(postChallenge({ vendorId, payload: data })).then(unwrapResult)
            .then(() => {
              setIsEditing(false);
              toast.success('Zaaktualizowane pomyślnie!');
              refresh();
            }).catch(onError);
        }

      }
    }
  });

  const onError = (e) => {
    switch(e.response?.data?.error) {
      case maxNumberOfChallengesErrorString:
        toast.error('Twój plan nie pozwala na więcej aktywnych wyzwań!');
        break;
    }
  };

  const renderAddImageText = () => {
    return <label className='vv-challenge__image vv-challenge__image--add'>
      <input type='file' id='single' onChange={onImageSelect}/>
      <p> + Dodaj zdjęcie</p>
    </label>;
  };

  const onImageSelect = (e) => {
    const file = e.target.files[0];
    setImage(file);
  };

  const renderImagePreview = () => {
    if (image && typeof image === 'object' && 'size' in image) {
      const imageUrl = URL.createObjectURL(image);
      return <img src={imageUrl} alt='Preview' className='vv-challenge__image-preview'/>;
    }
    else if (image && typeof image === 'string') {
      return <img src={image} alt='Preview' className='vv-challenge__image-preview'/>;
    }
    return renderAddImageText();
  };


  const renderImage = () => {
    return renderImagePreview(challenge?.photo);
  };

  const deleteImage = () => {
    setImage(null);
  };

  return <div className='vv-challenge'>
    <div className='vv-challenge__item'>
      <div className={!isEditing ? 'vv-challenge__disabled' : ''}>
        <Input label='Nazwa nagrody' onBlur={formik.handleBlur} onChange={formik.handleChange} name='prize_name'
               id='prize_name' value={formik.values.prize_name}
               textError={formik.touched.prize_name && formik.errors.prize_name}/>
        <Input type='number' label='Ilość transakcji' onBlur={formik.handleBlur} onChange={formik.handleChange} name='amount_of_transactions_required'
               id='amount_of_transactions_required' value={formik.values.amount_of_transactions_required}
               textError={formik.touched.amount_of_transactions_required && formik.errors.amount_of_transactions_required}/>
        <Input type='number' label='Limit czasowy (w dniach)' onBlur={formik.handleBlur} onChange={formik.handleChange} name='time_limit'
               id='time_limit' value={formik.values.time_limit}
               textError={formik.touched.time_limit && formik.errors.time_limit}/>
      </div>
      <div className='mb-20'></div>
      {!isEditing && !isNew && <Button buttonType={ButtonType.BLACK} onClick={() => setIsEditing(!isEditing)} text={'Edytuj'}></Button>}
      {(isEditing || isNew) && <Button disabled={!formik.isValid && formik.dirty} buttonType={ButtonType.BLACK} type='submit' onClick={() => formik.handleSubmit()} text={'Zapisz'}></Button>}
    </div>

    <div style={{flex: 1}} className={!isEditing ? 'vv-challenge__disabled' : ''}>
      <div className='vv-challenge__item vv-challenge__center'>
        {renderImage()}
        {(image || !!challenge?.photo) && <img className='vv-challenge__delete-icon' onClick={deleteImage} src={trashIcon} alt='trash icon'/>}
        <p className='vv-challenge__simple'>Klient zobaczy nastepujący komunikat:</p>
        <p>&quot;Użyj zniżkę {formik.values.amount_of_transactions_required} razy i odbierz nagrodę - { formik.values.prize_name } &quot;</p>
      </div>
    </div>

    <div className={`vv-challenge__last ${!isEditing ? 'vv-challenge__disabled' : ''}`}>
        <p>Aktywne</p>
        <Switch onChange={setIsActive} checked={isActive} />
    </div>
  </div>;
};
